import { getRandomIntInclusive } from "../utils/inputGeneratorHelpers";

const OPTIONS = [
  [
    ["5","3",".",".","7",".",".",".","."],
    ["6",".",".","1","9","5",".",".","."],
    [".","9","8",".",".",".",".","6","."],
    ["8",".",".",".","6",".",".",".","3"],
    ["4",".",".","8",".","3",".",".","1"],
    ["7",".",".",".","2",".",".",".","6"],
    [".","6",".",".",".",".","2","8","."],
    [".",".",".","4","1","9",".",".","5"],
    [".",".",".",".","8",".",".","7","9"]
],
[   
    [".",".",".",".",".","7",".",".","9"],
    [".","4",".",".","8","1","2",".","."],
    [".",".",".","9",".",".",".","1","."],
    [".",".","5","3",".",".",".","7","2"],
    ["2","9","3",".",".",".",".","5","."],
    [".",".",".",".",".","5","3",".","."],
    ["8",".",".",".","2","3",".",".","."],
    ["7",".",".",".","5",".",".","4","."],
    ["5","3","1",".","7",".",".",".","."]
],
[
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."],
    [".",".",".",".",".",".",".",".","."]    
]

]

const sudokuSolverGenerator = () => {
    const n = OPTIONS.length;
    const idx = getRandomIntInclusive(0,n-1);
    const retObj = {"sudokuBoard": OPTIONS[idx]};
    //console.log(`sudokuSolverGenerator retObj: ${JSON.stringify(retObj)}`);
    return retObj;
}

export default sudokuSolverGenerator;